import { render, staticRenderFns } from "./committeeEvents.vue?vue&type=template&id=d8b5dc30&scoped=true&"
import script from "./committeeEvents.vue?vue&type=script&lang=js&"
export * from "./committeeEvents.vue?vue&type=script&lang=js&"
import style0 from "./committeeEvents.vue?vue&type=style&index=0&id=d8b5dc30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b5dc30",
  null
  
)

export default component.exports